import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faExclamationTriangle,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons"

import Spacer from "~/components/Spacer"
import CheckImage from "~/components/svg/GreenCheckCircle"
import DesktopContainer from "~/components/DesktopContainer"
import Hand from "../../../public/static/images/png/hand.png"
import Divider from "~/components/traffic-tickets/steps/Divider"
import Tooltip from "~/components/Tooltip"

const PaymentAccepted = styled.div`
  font-family: ${(props) => props.theme.fonts.avenirNextHeavy};
  font-size: 2.375em;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const VerticalDivider = styled.div`
  height: 100%;
  width: 1px;
  background-color: ${(props) => props.theme.colors.divider};
`

const ListsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 1em;
  flex-wrap: wrap;
`

const TicketListContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 16px;
`

const TicketList = styled.ul`
  list-style-type: none;
  padding: 0;
`

const TicketListItem = styled.li`
  margin-bottom: 12px;
  display: flex;
  align-items: center;
`

const PaidTicket = styled(TicketListItem)`
  color: green;
`

const UnpaidTicket = styled(TicketListItem)`
  color: red;
`

const TicketIcon = styled(FontAwesomeIcon)`
  margin-right: 8px;
`

const SuccessContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
`

const SuccessText = styled.div`
  font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  font-size: 1.8rem;
`

const ImageBackground = styled.div`
  background-repeat: no-repeat;
  background-position: left top 9%;
  background-size: 170px 260px;
  background-image: url(${Hand});
`

const TitleWraper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const SubText = styled.div`
  color: ${(props) => props.theme.colors.text.label};
  font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  line-height: 1.4375rem;
  font-size: 1.25rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  max-width: 690px;
  padding: 0.8em 1em 0.25em 1em;
  ${(props) => props.theme.media.smallDesktop`
      max-width: 500px;
  `}
  ${(props) => props.theme.media.mobile`
      max-width: 200px;
  `}
  width: 100%;
`

const SubText2 = styled.div`
  color: ${(props) => props.theme.colors.text.label};
  font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  line-height: 1.4375rem;
  font-size: 1rem;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  max-width: 610px;
  padding: 0.5em 1em 0.25em 1em;
`

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  width: 470px;
  flex-shrink: 1;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 9px 24px rgba(0, 0, 0, 0.1);
  ${(props) => props.theme.media.smallDesktop`
    margin-top: 25px;
  `}
  ${(props) => props.theme.media.mobile`
    width: 100%;
  `}
`

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

const ItemName = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  color: ${(props) => props.theme.colors.text.label};
  font-size: 1.125em;
`
const ItemAmount = styled.div`
  font-family: ${(props) => props.theme.fonts.avenirNextBold};
  color: ${(props) => props.theme.colors.text.label};
  font-size: 1.125em;
`

const SubtotalAmount = styled.div`
  font-family: ${(props) => props.theme.fonts.avenirNextDemi};
  color: ${(props) => props.theme.colors.success};
  font-size: 1.7em;
`

const AmountBreakdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1em;
`
@inject((all) => ({
  isMobile: all.store.ui.isMobile,
  tickets:all.store.parkingFlow.results.paySelected,
  userCredits: all.store.auth.user.credits,
  cardScheme: all.store.payment.evervault,
  totalSelectedPayableAmount: all.store.parkingFlow.results.totalSelectedPayableAmount,
  feeForSelectedPayable: all.store.parkingFlow.results.feeForSelectedPayable,
  additionalFeePerTicket: all.store.parkingFlow.results.additionalFeePerTicket,
  totalServiceFee: all.store.parkingFlow.results.totalServiceFee,
  paySubTotal: all.store.parkingFlow.results.paySubtotal,
  cityPayConfirmationID: all.store.payment.cityPayConfirmationID,
  cityPayNotPaidList: all.store.payment.cityPayNotPaidList,
}))
@observer
class PaySuccessEverVault extends Component {
  render() {
    const {
      userCredits,
      cityPayNotPaidList,
      totalSelectedPayableAmount,
      feeForSelectedPayable,
      additionalFeePerTicket,
      totalServiceFee,
      paySubTotal,
      cardScheme,
    } = this.props

    let finalTotalSelectedPayableAmount = totalSelectedPayableAmount
    let finalFeeForSelectedPayable = feeForSelectedPayable
    let finalTotalServiceFee = totalServiceFee
    let finalPaySubTotal = paySubTotal
    let finalPaidList = this.props.tickets
    if (userCredits > 0) {
      finalPaySubTotal =  finalPaySubTotal + userCredits - Math.min(finalTotalServiceFee, userCredits)
      finalTotalServiceFee -= Math.min(finalTotalServiceFee, userCredits)
    }
    if (cityPayNotPaidList.length > 0) {
      cityPayNotPaidList.forEach((ticketNotPaid) => {
        const targetTicket = this.props.tickets.find(
          (ticket) => ticket.ticketID === ticketNotPaid.ticketID
        )
        finalTotalSelectedPayableAmount -= targetTicket.amountDue
        finalPaidList = finalPaidList.filter(
          (ticket) => ticket.ticketID !== targetTicket.ticketID
        )
      })
      finalFeeForSelectedPayable = finalTotalSelectedPayableAmount * 0.02
      if (finalTotalServiceFee > 0) {
        finalTotalServiceFee -= cityPayNotPaidList.length * additionalFeePerTicket
        if(finalTotalServiceFee < 0) {
          finalTotalServiceFee = 0
        }
      }
      finalPaySubTotal = finalTotalSelectedPayableAmount + finalFeeForSelectedPayable + finalTotalServiceFee
    }
    return (
      <DesktopContainer>
        <ImageBackground>
          <Spacer mobile={30} desktop={56} />
          <TitleWraper>
            <Spacer mobile={10} desktop={6} />
            <PaymentAccepted>
              PAYMENT ACCEPTED BY NYC
              <Spacer mobile={2} desktop={5} direction="width" />
              <SuccessContainer>
                <CheckImage size={33} />
                <Spacer mobile={2} desktop={5} direction="width" />
                <SuccessText>Success</SuccessText>
              </SuccessContainer>
            </PaymentAccepted>
            <Spacer mobile={15} desktop={29} />
            <CardContainer>
              <SubText style={{ margin: "10px 0" }}>
                <strong>What happens next?</strong>
              </SubText>
              <SubText2>
                NYC will process your payment within 4 business days. During
                this time, your ticket may appear as paid or unpaid, after
                which, your ticket will be satisfied.
              </SubText2>
              <SubText2>
                Note: You will see 3 charges on your card statement, two from
                NYC and one from us, totaling ${finalPaySubTotal.toFixed(2)} - this is
                normal.
              </SubText2>
              <Spacer mobile={15} desktop={25} />
            </CardContainer>
            <Spacer mobile={15} desktop={29} />
            <CardContainer>
              <AmountBreakdownContainer>
                <div>
                  <ItemName>
                    <b>ORDER SUMMARY</b>
                  </ItemName>
                </div>
                <Divider top={16} bottom={16} />
                <InfoRow>
                  <ItemName>
                    DOF PARKINGANDCAMERA TIX
                    <Tooltip
                      message="This is the total fine amount paid to NYC DOF."
                      icon="info"
                      size={16}
                    />
                  </ItemName>
                  <ItemAmount>${finalTotalSelectedPayableAmount.toFixed(2)}</ItemAmount>
                </InfoRow>
                <Divider top={16} bottom={16} />
                <InfoRow>
                  <ItemName>
                    PRKING&CAMERATIX SERVFEE
                    <Tooltip
                      message="This is the 2% credit card fee charged by NYC DOF."
                      icon="info"
                      size={16}
                    />
                  </ItemName>
                  <ItemAmount>${finalFeeForSelectedPayable.toFixed(2)}</ItemAmount>
                </InfoRow>
                {finalTotalServiceFee > 0 && (
                <>
                  <Divider top={16} bottom={16} />
                  <InfoRow>
                    <InfoRow>
                      <ItemName>
                        {cardScheme === 'discover' ? (
                          <>
                            NYCTICKET {this.props.tickets[0].plateNumber} WIN
                            <Tooltip
                              message="This flat fee enables WinIt to securely process your payment."
                              icon="info"
                              size={16}
                            />
                          </>
                            ) : (
                              <>
                                NYC*TICKET {this.props.tickets[0].plateNumber} WINIT
                                <Tooltip
                                  message="This flat fee enables WinIt to securely process your payment."
                                  icon="info"
                                  size={16}
                                />
                              </>
                            )}
                      </ItemName>
                    </InfoRow>
                    <ItemAmount>${finalTotalServiceFee.toFixed(2)}</ItemAmount>
                  </InfoRow>
                </>
                )}
                <Divider top={16} bottom={16} />
                <InfoRow>
                  <ItemName>
                    DOF CONFIRMATION ID
                    <Tooltip
                      message="This is a confirmation receipt id from NYC DOF."
                      icon="info"
                      size={16}
                    />
                  </ItemName>
                  <ItemAmount>{this.props.cityPayConfirmationID}</ItemAmount>
                </InfoRow>
                <Divider top={16} bottom={0} />
                <Spacer mobile={10} desktop={10} />
                <InfoRow>
                  <ItemName>
                    <b>Total</b>
                  </ItemName>
                  <SubtotalAmount>${finalPaySubTotal.toFixed(2)}</SubtotalAmount>
                </InfoRow>
              </AmountBreakdownContainer>
            </CardContainer>
            <Spacer mobile={10} desktop={29} />
            <CardContainer>
              <ListsContainer>
                <TicketListContainer>
                  <ItemName>
                    <b>PAID TICKETS</b>
                  </ItemName>
                  <Divider top={5} bottom={5} />
                  <TicketList>
                    {finalPaidList.map((ticket) => (
                      <PaidTicket key={ticket.ticketID}>
                        <TicketIcon icon={faCheckCircle} />
                        <span> #{ticket.ticketID}</span>
                      </PaidTicket>
                    ))}
                  </TicketList>
                </TicketListContainer>
                {cityPayNotPaidList.length > 0 && (
                  <>
                    <VerticalDivider />
                    <TicketListContainer>
                      <ItemName>
                        <b>UNPAID TICKETS</b>
                      </ItemName>
                      <Divider top={5} bottom={5} />
                      <TicketList>
                        {cityPayNotPaidList.map((item) => (
                          <UnpaidTicket key={item.ticketID}>
                            <TicketIcon icon={faExclamationTriangle} />
                            <span>
                              #{item.ticketID} <br /> Reason: {item.error}
                            </span>
                          </UnpaidTicket>
                        ))}
                      </TicketList>
                    </TicketListContainer>
                  </>
                )}
              </ListsContainer>
            </CardContainer>
          </TitleWraper>
        </ImageBackground>
      </DesktopContainer>
    )
  }
}

export default PaySuccessEverVault
